import { BBOT_DJANGO_SERVER } from "Config";
import { OPContainer, PageLoadingSpinner, Space } from "top-component-library";
import { LegacyLinkAlert } from "./styles";
import { MOVED_CARDS } from "./constants";
import { useAccountSettings } from "./useAccountSettings";
import { useIntegrationsRemnant } from "./useIntegrationsRemnant";
import { useOrderRateLimits } from "./useOrderRateLimits";
import MovedSettingsCard from "./sections/MovedSettingsCard";
import AccountWideOrderSettingsCard from "./sections/AccountWideOrderSettingsCard";
import IntegrationsCard from "./sections/IntegrationsCard";
import SelfDeliveryCard from "./sections/SelfDeliveryCard";
import PartyTabDomainRestrictionsCard from "./sections/PartyTabDomainRestrictionsCard";
import CheckoutLimitationsCard from "./sections/CheckoutLimitationsCard";

const AccountSettings = ({ selectedCustomer, userInfo }) => {
  const settings = useAccountSettings(selectedCustomer);
  const orderRateLimits = useOrderRateLimits(selectedCustomer);
  const integrationsRemnant = useIntegrationsRemnant(selectedCustomer);
  const isAdmin = userInfo?.role === "admin";
  const legacyLink =
    BBOT_DJANGO_SERVER + (userInfo?.role === "admin" ? "/superuser/console/#!/settings" : "/owner/console/#!/settings");

  return (
    <OPContainer
      title="Account Settings"
      url="/account-settings"
      selectedCustomer={selectedCustomer}
      userInfo={userInfo}
    >
      <div className="margin-bottom-4">
        <LegacyLinkAlert
          message={
            <span>
              We&apos;ve updated our Account Settings page! We&apos;ll retire the old page soon but you can view it{" "}
              <a href={legacyLink}>here.</a>
            </span>
          }
        />
      </div>
      {settings.isLoading ? (
        <PageLoadingSpinner />
      ) : (
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {MOVED_CARDS.map((card) => (
            <MovedSettingsCard
              key={card.key}
              title={card.title}
              message={card.message}
              linkText={card.linkText}
              url={card.url}
            />
          ))}
          <SelfDeliveryCard
            enabled={settings.selfDeliveryEnabled}
            maxDeliveryMiles={settings.maxDeliveryMiles}
            allowedZipCodes={settings.allowedZipCodes}
            onSave={settings.saveSelfDelivery}
          />
          <IntegrationsCard
            isAdmin={isAdmin}
            connectedIntegrations={settings.connectedIntegrations}
            hasConnectedPosIntegration={settings.hasConnectedPosIntegration}
            remnant={integrationsRemnant}
          />
          {!orderRateLimits.isLoading && (
            <CheckoutLimitationsCard
              orderRateLimits={orderRateLimits.orderRateLimits}
              availableThrottleSettings={settings.availableThrottleSettings}
              customerId={selectedCustomer?.customer_id}
              onSave={orderRateLimits.saveOrderRateLimit}
              onDelete={orderRateLimits.deleteOrderRateLimits}
            />
          )}
          <AccountWideOrderSettingsCard
            minimumPaidOrderDollars={settings.minimumPaidOrderDollars}
            setMinimumPaidOrderDollars={settings.setMinimumPaidOrderDollars}
            allowFreeOrders={settings.allowFreeOrders}
            setAllowFreeOrders={settings.setAllowFreeOrders}
            allowFreeOrdersAfterPurchase={settings.allowFreeOrdersAfterPurchase}
            setAllowFreeOrdersAfterPurchase={settings.setAllowFreeOrdersAfterPurchase}
            onSave={settings.saveGuestCartProperties}
          />
          {settings.hostnameConfigs.length > 0 && (
            <PartyTabDomainRestrictionsCard
              tabsWorkAnywhere={settings.tabsWorkAnywhere}
              hostnameConfigs={settings.hostnameConfigs}
              onSave={settings.saveTabsWorkAnywhere}
            />
          )}
        </Space>
      )}
    </OPContainer>
  );
};

export default AccountSettings;
